import { createComponent } from "react-fela";
import { fluid } from "~/styleguide/utils";
import { gutters } from "~/styleguide";
import { textStyles } from "~/styleguide/typography";
import resourceData from "~/data/resource-data.json";
import get from "lodash.get";

export default function NoFilterResults() {
    // Get global `No results` message from json
    const message = get(resourceData, "data.acf.resources_no_results");

    return (
        <Container>
            <p>{message || "No results found. Please try another search."}</p>
        </Container>
    );
}

const Container = createComponent(() => ({
    textAlign: "center",
    minHeight: 300,
    "> p": textStyles.heading3,

    extend: [
        fluid("paddingV", gutters.vertical),
        fluid("paddingH", gutters.default)
    ]
}));
